import { useQuery } from "@tanstack/react-query";

import {
  getKBEquipmentTypeMeta,
  getKBTypes,
  type KBEquipmentSummary,
  type KBSensorSummary,
} from "./api/agent";

const EMPTY_SENSOR_TYPES: KBSensorSummary[] = [];

/**
 * Display metadata for equipment types sourced from the KB.
 * Same payload Tietopohja (`/knowledge-base`) uses for equipment-row icons:
 * `GET /kb/equipment-type-meta` → YAML `icon`.
 */
export function useEquipmentTypeMeta(): Record<string, KBEquipmentSummary> {
  const { data } = useQuery({
    queryKey: ["kb-equipment-type-meta"],
    queryFn: getKBEquipmentTypeMeta,
    staleTime: Infinity,
  });
  return data ?? {};
}

export function useKbSensorTypes(): KBSensorSummary[] {
  const { data } = useQuery({
    queryKey: ["kb-types"],
    queryFn: getKBTypes,
    staleTime: Infinity,
  });
  return data?.sensor_types ?? EMPTY_SENSOR_TYPES;
}

export {
  equipmentTypeIcon,
  equipmentTypeNameFi,
  findEquipmentTypeOption,
  groupedEquipmentTypeOptions,
  type EquipmentTypeGroup,
  type EquipmentTypeOption,
} from "./kb-catalog-nav";
